<template>
  <b-container fluid>
    <b-row class="justify-content-md-center">
      <b-col md="6" sm="12" class="mt-2">
        <p class="reg-heading-tab sign-up-heading">Signup Details</p>
      </b-col>
    </b-row>
    <div class="body-content sign-up-body">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
        <b-row class="justify-content-md-center">
          <b-col md="6" sm="12" class="mt-2">
            <div class="reg-tab-container">
              <b-form-group
                id="exampleInputGroup2"
                horizontal
                label="First Name"
                label-size="sm"
                label-for="inpfirstname"
              >
                <b-form-input
                  id="inpfirstname"
                  type="text"
                  v-model="form.FirstName"
                  size="sm"
                  placeholder="first name"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup3"
                horizontal
                label="Middle Name"
                label-size="sm"
                label-for="inpmiddlename"
              >
                <b-form-input
                  id="inpmiddlename"
                  type="text"
                  v-model="form.MiddleInitial"
                  size="sm"
                  placeholder="middle name"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="exampleInputGroup3"
                horizontal
                label="Last Name"
                label-size="sm"
                label-for="inplastname"
              >
                <b-form-input
                  id="inplastname"
                  type="text"
                  v-model="form.LastName"
                  size="sm"
                  placeholder="last name"
                ></b-form-input>
              </b-form-group>
              

              <b-form-group
                id="exampleInputGroup6"
                horizontal
                label="Email ID"
                label-size="sm"
                label-for="inpemail"
              >
                <b-form-input
                  id="inpemail"
                  type="email"
                  v-model="form.EmailID"
                  size="sm"
                  placeholder="email id"
                  @change="setUserName"
                ></b-form-input>
              </b-form-group>
             

              <b-form-group
                id="exampleInputGroup8"
                horizontal
                label="Mobile"
                label-size="sm"
                label-for="inpmobile"
              >
                <b-form-input
                  id="inpmobile"
                  type="number"
                  v-model="form.Mobile"
                  :state="mobileNumber"
                  size="sm"
                  min="1000000000"
                  max="9999999999"
                  placeholder="10 digit Mobile Number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="igrpusr"
                horizontal
                label="User Name"
                label-size="sm"
                label-for="exampleInput1"
              >
                <b-form-input
                  type="text"
                  placeholder="User Name"
                  size="sm"
                  v-model="form.UserName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="igrppwd"
                horizontal
                label="Password *"
                label-size="sm"
                label-for="exampleInput4"
              >
                <b-form-input
                  type="password"
                  placeholder="password"
                  size="sm"
                  v-model="form.Password"
                  :state="passwordConfirmed"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="igrppwdc"
                horizontal
                label="Confirm Password *"
                label-size="sm"
                label-for="exampleInput1"
              >
                <b-form-input
                  type="password"
                  placeholder="password"
                  size="sm"
                  v-model="confirmpassword"
                  :state="passwordConfirmed"
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center">
          <b-col
            md="6"
            sm="12"
            style="text-align: right"
            class="button-wrap sign-up-wrap"
          >
            <small for="exampleInputEmail1" class="label-text">
              Please do next math and click 
              <i class="fa fa-check"></i> key
              <span>* </span>
            </small>
            <captcha
              :callSuccess="captchaOk"
              color="black"
              resolve="text"
              :isAuth="auth"
              class="float-right"
            ></captcha>
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center">
          <b-col
            md="6"
            sm="12"
            style="text-align: right"
            class="button-wrap sign-up-wrap"
          >
            <b-button type="submit" variant="primary" v-if="!isSaved"
              >Submit</b-button
            >
            <b-button type="reset" variant="danger" v-if="!isSaved"
              >Reset</b-button
            >
            <b-button variant="secondary" v-if="isSaved" @click="onClickButton"
              >Next</b-button
            >
          </b-col>
        </b-row>
        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert = false"
          :variant="variant"
          >{{ alertText }}</b-alert
        >
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
      </b-form>
    </div>
    <!-- </div> -->
    <b-modal
      ref="otpModal"
      id="otpCheckPopUp"
      centered
      hide-footer
      title="OTP Verifcation"
      size="sm"
    >
      <div class="justify-content-md-center">
        <p style="font-size: 0.75rem">
          We have sent OTP to your mobile. Please verify OTP.
        </p>
        <b-form-input
          id="otpnumber"
          type="number"
          v-model="form.otp"
          required
          size="sm"
          placeholder="Please Enter OTP Number"
        >
        </b-form-input>
        <b-btn
          variant="success"
          size="sm"
          class="m-2 float-right"
          @click="onSubmitOTP"
          >Submit</b-btn
        >
        <b-btn
          variant="link"
          size="sm"
          class="m-2 float-right"
          @click="CreateOTP"
          >Resend OTP</b-btn
        >
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import PortalNavbar from "@/components/PortalNavbar";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import captcha from "@/components/Captcha/Captcha.vue";
import sha256 from "js-sha256";
export default {
  props: ["signuptype"],
  components: { Spinner, PortalNavbar, DatePicker, captcha },
  data() {
    return {
      auth: false,
      DOB: null,
      form: {
        RegistrationType: 0,
        FirstName: "",
        MiddleInitial: "",
        LastName: "",
        DOB: "2000-01-01",
        AddharCardNumber: "",
        Gender: true,
        UserName: "",
        EmailID: "",
        Mobile: "",
        Password: "",
        CompanyName: "",
        otp: "",
      },
      otpnumber: "",
      isSaved: false,
      confirmpassword: "",
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      otpvalidate: {
        MobileNumber: "",
        OTP: "",
      },
      // options: [
      //   { value: 0, text: "Resgistration as New Secuirty Guard" },
      //   { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
      //   {
      //     value: 2,
      //     text:
      //       "Recommanded by registered Principal Employer for Registration and Allotment"
      //   },
      //   { value: 3, text: "Registration on Compassionate Ground" },
      //   { value: 4, text: "Registration by Court Orders" },
      //   { value: 11, text: "Registration of Principal Employer" },
      //   {
      //     value: 12,
      //     text: "Registration of Security Guards Working with Private Agency"
      //   },
      //   { value: 13, text: "Registration of Employer Agency" }
      // ]
    };
  },
  watch: {
    // form: {
    //   handler: function(newValue, oldValue) {
    //     if (newValue.EmailID != "" && newValue.UserName=="") {
    //       this.form.UserName = newValue.EmailID;
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    validateAge() {
      // console.log('1');
      //let age = this.calculateAge(this.form.DOB);
      let age = this.calculateAge(this.DOB);
      if (age < 18 || age >= 58) {
        return false;
      } else {
        return true;
      }
    },
    validateAadhar() {
      if (this.form.AdharNo == null) {
        return true;
      }

      if (this.form.AdharNo.length == 0) {
        return true;
      } else if (this.form.AdharNo != null) {
        var adharformat = /^\d{12}$/;
        if (this.form.AdharNo.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    mobileNumber() {
      var phoneno = /^\d{10}$/;
      if (this.form.Mobile.match(phoneno)) {
        if (this.form.UserName == "") {
          this.form.UserName = this.form.Mobile;
        }
        return true;
      } else {
        return false;
      }
    },
    passwordConfirmed() {
      if (
        this.form.Password == this.confirmpassword &&
        this.form.Password != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    switch (this.signuptype) {
      case "employer":
        this.form.RegistrationType = 11;
        break;
      case "agency":
        this.form.RegistrationType = 13;
        break;
      case "pvtguard":
        this.form.RegistrationType = 12;
        break;
      case "newapplication":
        this.options = [
          { value: 0, text: "Resgistration as New Secuirty Guard" },
          { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
          {
            value: 2,
            text: "Recommanded by registered Principal Employer for Registration and Allotment",
          },
          { value: 3, text: "Registration on Compassionate Ground" },
          { value: 4, text: "Registration by Court Orders" },
        ];
        break;
      case "all":
        this.options = [
          { value: 0, text: "Resgistration as New Secuirty Guard" },
          { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
          {
            value: 2,
            text: "Recommanded by registered Principal Employer for Registration and Allotment",
          },
          { value: 3, text: "Registration on Compassionate Ground" },
          { value: 4, text: "Registration by Court Orders" },
          { value: 11, text: "Registration of Principal Employer" },
          {
            value: 12,
            text: "Registration of Security Guards Working with Private Agency",
          },
          { value: 13, text: "Registration of Employer Agency" },
        ];
        break;
    }
  },
  methods: {
    captchaOk() {
      this.auth = true;
    },
    setUserName() {
      if (this.form.UserName == "") {
        this.form.UserName = this.form.EmailID;
      }
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      //this.$emit("clicked");
      this.$router.push("/");
    },
    hideModal() {
      this.$refs.otpCheckPopUp.hide();
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n;
    },
    onSubmitOTP(evt) {
      evt.preventDefault();
      this.CreateOTP();
      this.showDismissibleAlert = false;
      this.isLoading = true;
      if (!this.validateAadhar) {
        this.alertText = "Please verify the Aadhar number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      if (!this.passwordConfirmed) {
        this.alertText = "Please verify the password and confirm password.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = true;
        return;
      }
      //this.form.DOB = Formatter.convertDateFormatYMD(this.DOB);
      let promise = apis.SignUpLoanUser(this.form);
      promise
        .then((response) => {
          //console.log("Reponse", response);
          if (response.status == 200) {
            //chck message
            //this.alertText = response.body.message;
            this.alertText = response.body;
            if (this.alertText == "User Created Successfully") {
              this.$refs.otpModal.hide();
              // let usr = {
              //   UserId: response.body.loginid,
              //   FirstName: this.form.FirstName,
              //   MiddleInitial: this.form.MiddleInitial,
              //   LastName: this.form.LastName,
              //   EmailID: this.form.EmailID,
              //   Mobile: this.form.Mobile
              // };
              // this.$store.dispatch("signup", {
              //   token: "New Token",
              //   user: usr
              // });

              this.variant = "success";
              this.isSaved = true;
              //this.$router.push("/");
            } else {
              this.variant = "warning";
            }
            this.showDismissibleAlert = true;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message || "Error while saving data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.auth) {
        this.CreateOTP();
      } else {
        this.$dialog.alert("Please enter Captcha");
      }
    },
    CreateOTP() {
      this.showDismissibleAlert = false;
      this.isLoading = true;
      if (!this.validateAadhar) {
        this.alertText = "Please verify the Aadhar number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      if (!this.passwordConfirmed) {
        this.alertText = "Please verify the password and confirm password.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      let promise = apis.ValidateLoanUser(this.form);
      promise
        .then((response) => {
          //console.log("Reponse", response);
          if (response.status == 200) {
            //chck message
            if (response.body.message == "SUBMIT_SUCCESS ") {
              this.$root.$emit("bv::show::modal", "otpCheckPopUp");
            } else {
              this.alertText =
                response.body.message || "Error while saving data";
              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body || "Error while saving data";
            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.alertText = err.message || "Error while saving data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onReset(evt) {
      evt.preventDefault();
      this.form.RegistrationType = "";
      this.form.FirstName = "";
      this.form.MiddleInitial = "";
      this.form.LastName = "";
      this.form.UserName = "";
      this.form.EmailID = "";
      this.form.Mobile = "";
      this.form.Password = "";
      this.form.DOB = "";

      this.isSaved = false;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
  border: none;
}

.card {
  border: none;
}

.sign-up-body {
  padding-top: 0;
}

.sign-up-wrap {
  margin-bottom: 30px;
}

.sign-up-heading {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/Signup.vue